export enum TotalItemEnum {
    LAST_YEAR = 'lastYear',
    PROJECTION = 'inProjection',
    BUDGET_PROPOSAL = 'inBudgetProposal',
}
